export const HF_CONFIG = {
  CLIENT_ID: "",
  STORAGE_KEY: "hf_oauth",
  SCOPE: "openid profile",
  PROD_URL: "https://braindecode-eeg-finetune-arena.hf.space",
  DEV_URL: "http://localhost:7860"
};
